import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProductSection } from './components/ProductSection';
import { PricingSection } from './components/PricingSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FooterSection } from './components/FooterSection';
import { BuyerPopup, StickyCTA } from './components/Overlays';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-court-night font-sans selection:bg-cyan-400 selection:text-slate-950" data-id="element-0" data-mp="2rit1x23ijoou">
      <MetaPixel data-id="element-1" data-mp="2mjzlp1wudjkz" />
      <HeroSection data-id="element-2" data-mp="31agnimde2bie" />
      <ProductSection data-id="element-3" data-mp="31ayqe1uk3nza" />
      <PricingSection data-id="element-4" data-mp="31bi8bik7icdb" />
      <SocialProofSection data-id="element-5" data-mp="31ctfztgrw49p" />
      <FooterSection data-id="element-6" data-mp="2wka1mua9h53u" />

      {/* Overlays */}
      <BuyerPopup data-id="element-7" data-mp="2wiff5bjcd4xn" />
      <StickyCTA data-id="element-8" data-mp="2whx8rm2ytac0" />
    </div>;
}